import React from "react";
import { ImSpinner2 } from "react-icons/im";

const Spinner = ({ className = "w-4 h-4" }) => {
  return <ImSpinner2 className={` animate-spin text-gray-400 ${className}`} />;
};

export default Spinner;
